import mime from "mime";

/**
 * Get the MIME type from the extension
 * @param extension - The extension of the file [.png, .jpg, .jpeg, .pdf] or [.png]
 * @returns The MIME type object for react-dropzone Accept type
 */
const getMimeTypeFromExtension = (extension: string[]): Record<string, string[]> => {
  if (!Array.isArray(extension)) return {};
  return extension.reduce((acc, ext) => {
    const mimeType = mime.getType(ext);
    if (mimeType) {
      acc[mimeType] = [ext];
    }
    return acc;
  }, {} as Record<string, string[]>);
};

export default getMimeTypeFromExtension;

